import { defineMessages } from 'react-intl-next';

export default defineMessages({
	createPageTitle: {
		defaultMessage: 'Create new page',
		description: 'Title for the create page modal',
		id: 'create.custom.page.title',
	},
	createPageDescription: {
		defaultMessage: 'Create a new page for your help center.',
		description: 'Description for the create page form',
		id: 'create.custom.page.description',
	},
	pageNameLabel: {
		defaultMessage: 'Page name',
		description: 'Label for the page name field',
		id: 'create.custom.page.name.label',
	},
	pageNamePlaceholder: {
		defaultMessage: 'Enter page name',
		description: 'Placeholder for the page name field',
		id: 'create.custom.page.name.placeholder',
	},
	pageNameRequired: {
		defaultMessage: 'Page name is required',
		description: 'Error message when page name is empty',
		id: 'create.custom.page.name.required',
	},
	pageNameTooLong: {
		defaultMessage: 'Page name must be 100 characters or less',
		description: 'Error message when page name exceeds limit',
		id: 'create.custom.page.name.too.long',
	},
	pageDescriptionLabel: {
		defaultMessage: 'Description (optional)',
		description: 'Label for the page description field',
		id: 'create.custom.page.description.label',
	},
	pageDescriptionPlaceholder: {
		defaultMessage: 'Enter page description',
		description: 'Placeholder for the page description field',
		id: 'create.custom.page.description.placeholder',
	},
	pageDescriptionTooLong: {
		defaultMessage: 'Description must be 256 characters or less',
		description: 'Error message when description exceeds limit',
		id: 'create.custom.page.description.too.long',
	},
	cancelButton: {
		defaultMessage: 'Cancel',
		description: 'Cancel button text',
		id: 'create.custom.page.cancel',
	},
	createButton: {
		defaultMessage: 'Create',
		description: 'Create button text',
		id: 'create.custom.page.create',
	},
	actionDuplicateCopyOfText: {
		defaultMessage: "Copy of ''{value}''",
		description: 'Prefix text for the name of duplicated page',
		id: 'create.custom.page.action.duplicate.copy.of.text',
	},
	customPageCreateFormTitle: {
		defaultMessage: 'Create page',
		description: 'Custom page create form title',
		id: 'create.custom.page.form.title',
	},
	customPageDuplicateFormTitle: {
		defaultMessage: "Duplicate ''{value}''",
		description: 'Custom page duplicate form title',
		id: 'create.custom.page.duplicate.form.title',
	},
	customPageUpdateDetailsTitle: {
		defaultMessage: 'Edit page details',
		description: 'Custom page edit form title',
		id: 'create.custom.page.update.form.title',
	},
	customPageFormDescription: {
		defaultMessage: 'Required fields are marked with an asterisk',
		description: 'Custom page form description',
		id: 'create.custom.page.form.description',
	},
	customPageCreateErrorTitle: {
		defaultMessage: "We couldn't create your page",
		description: 'Title message for create custom page error',
		id: 'create.custom.page.error.title',
	},
	customPageCreateSuccessTitle: {
		defaultMessage: "''{value}'' created",
		description: 'Title message for create custom page success',
		id: 'create.custom.page.success.title',
	},
	customPageCreateSuccessDesc: {
		defaultMessage: 'Edit page layout',
		description: 'Description message for create custom page success',
		id: 'create.custom.page.success.description',
	},
	customPageDuplicateSuccessTitle: {
		defaultMessage: "''{value}'' created",
		description: 'Title message for duplicate custom page success',
		id: 'create.custom.page.duplicate.success.title',
	},
	customPageUpdateErrorTitle: {
		defaultMessage: "We couldn't update page details",
		description: 'Title message for update custom page error',
		id: 'create.custom.page.update.error.title',
	},
	customPageUpdateSuccessTitle: {
		defaultMessage: "Details for ''{value}'' updated",
		description: 'Title message for update custom page success',
		id: 'create.custom.page.update.success.title',
	},
	customPageGenericErrorDesc: {
		defaultMessage: 'Refresh the page and try again.',
		description: 'Generic description message for custom page error',
		id: 'create.custom.page.error.description.generic',
	},
	customPageHardLimitErrorTitle: {
		defaultMessage: "You've already created 100 custom pages",
		description: 'Message title for custom page hard limit reached error',
		id: 'create.custom.page.hard.limit.error.title',
	},
	customPageHardLimitErrorDescription: {
		defaultMessage: 'Delete a page to create another one.',
		description: 'Message description for custom page hard limit reached error',
		id: 'create.custom.page.hard.limit.error.description',
	},
	customPageAlreadyExistedErrorTitle: {
		defaultMessage: 'A page with this name already exists on your help center',
		description: 'Error message title when custom page with same name already exists',
		id: 'create.custom.page.already.existed.title.error',
	},
	customPageAlreadyExistedErrorDescription: {
		defaultMessage: 'Try again with a different name.',
		description: 'Error message description when custom page with same name already exists',
		id: 'create.custom.page.already.existed.description.error',
	},
});
